<template>
    <div>
        <main class="relative flex flex-col">
            <div class="w-full px-4 md:px-6">
                <div class="flex flex-col">
                    <div class="w-full">
                        <!-- Vertical Timeline #3 -->
                        <div
                            :class="{ 'md:before:ml-[10.2rem]': isLeftTitle }"
                            class="space-y-8 h-fit relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:translate-x-0 before:h-full before:w-0.5 before:bg-emerald-300">
                            <div
                                v-for="(item, index) in items"
                                :key="index"
                                class="relative"
                                :class="{ 'divide-y': index < items.length - 1 }">
                                <div class="md:flex md:space-x-4 mb-3 items-center">
                                    <slot
                                        v-if="isLeftTitle"
                                        name="leftContent"
                                        :item="item"
                                        class="mt-2 w-28 h-96">
                                        <span
                                            class="mt-2 inline-flex items-center justify-center text-xs font-semibold uppercase w-28 h-6 mb-3 sm:mb-0 text-emerald-600 bg-emerald-100 rounded-full">
                                            {{ item[keyLeftTitle] || 'left title' }}
                                        </span>
                                    </slot>
                                    <div class="flex space-x-4 md:space-x-2 md:space-x-reverse">
                                        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow md:order-1">
                                            <slot
                                                name="icon"
                                                :item="item">
                                                <component
                                                    :is="item.icon"
                                                    v-if="item.icon"
                                                    class="icon w-5 h-5"
                                                    :class="item.classIcon"
                                                    aria-hidden="true" />

                                                <span v-else>
                                                    {{ index + 1 }}
                                                </span>
                                            </slot>
                                        </div>
                                    </div>
                                    <slot
                                        name="content"
                                        :item="item"
                                        class="mt-2">
                                        <div
                                            v-if="!isLeftTitle"
                                            class="flex items-center mt-2">
                                            <span v-if="keyLeftTitle">
                                                {{ item[keyLeftTitle] }}
                                            </span>
                                        </div>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  isLeftTitle: {
    type: Boolean,
    default: false
  },
  keyLeftTitle: {
    type: String,
    default: ''
  },
  keyContent: {
    type: String,
    default: ''
  },
  keySlot: {
    type: String,
    default: '_id'
  }
})

const { items, isLeftTitle, keyLeftTitle, keyContent } = toRefs(props)
</script>
